var map = {
	"./template.bet575": 1574,
	"./template.bet575.tsx": 1574,
	"./template.bet777": 1575,
	"./template.bet777.tsx": 1575,
	"./template.betblast": 1576,
	"./template.betblast.tsx": 1576,
	"./template.betgalaxy": 1577,
	"./template.betgalaxy.tsx": 1577,
	"./template.betprofessor": 1578,
	"./template.betprofessor.tsx": 1578,
	"./template.betroyale": 1579,
	"./template.betroyale.tsx": 1579,
	"./template.betstride": 1580,
	"./template.betstride.tsx": 1580,
	"./template.buffalobet": 1581,
	"./template.buffalobet.tsx": 1581,
	"./template.chromabet": 1582,
	"./template.chromabet.tsx": 1582,
	"./template.default": 90,
	"./template.default.tsx": 90,
	"./template.fiestabet": 1583,
	"./template.fiestabet.tsx": 1583,
	"./template.forsport": 1584,
	"./template.forsport.tsx": 1584,
	"./template.gigabet": 1585,
	"./template.gigabet.tsx": 1585,
	"./template.goldenbet888": 1586,
	"./template.goldenbet888.tsx": 1586,
	"./template.goldenrush": 1587,
	"./template.goldenrush.tsx": 1587,
	"./template.hyperbet": 1588,
	"./template.hyperbet.tsx": 1588,
	"./template.juicybet": 1589,
	"./template.juicybet.tsx": 1589,
	"./template.junglebet": 1590,
	"./template.junglebet.tsx": 1590,
	"./template.magnumbet": 1591,
	"./template.magnumbet.tsx": 1591,
	"./template.oldgill": 1592,
	"./template.oldgill.tsx": 1592,
	"./template.puntcity": 1593,
	"./template.puntcity.tsx": 1593,
	"./template.puntgenie": 1594,
	"./template.puntgenie.tsx": 1594,
	"./template.pyramidbet": 1595,
	"./template.pyramidbet.tsx": 1595,
	"./template.questbet": 1596,
	"./template.questbet.tsx": 1596,
	"./template.slambet": 1597,
	"./template.slambet.tsx": 1597,
	"./template.sterlingparker": 1598,
	"./template.sterlingparker.tsx": 1598,
	"./template.sugarcastle": 1599,
	"./template.sugarcastle.tsx": 1599,
	"./template.templebet": 1600,
	"./template.templebet.tsx": 1600,
	"./template.titanbet": 1601,
	"./template.titanbet.tsx": 1601,
	"./template.ts": 982,
	"./template.vikingbet": 1602,
	"./template.vikingbet.tsx": 1602,
	"./template.volcanobet": 1603,
	"./template.volcanobet.tsx": 1603,
	"./template.wellbet": 1604,
	"./template.wellbet.tsx": 1604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2444;